if (!window.fasmedToast) {
  window.fasmedToast = function (html, ok) {
    var d = document.createElement('div');
    d.setAttribute('role', 'status');
    d.style.cssText =
      'position:fixed;left:50%;top:24px;transform:translate(-50%,-20px);opacity:0;z-index:100000;' +
      'background:' + (ok ? '#137a43' : '#b3261e') + ';color:#fff;padding:14px 22px;border-radius:12px;' +
      'font-size:15px;font-weight:600;line-height:1.4;box-shadow:0 8px 30px rgba(0,0,0,.25);transition:all .3s ease;' +
      'max-width:92vw;text-align:center';
    d.innerHTML = html;
    document.body.appendChild(d);
    requestAnimationFrame(function () { d.style.opacity = '1'; d.style.transform = 'translate(-50%,0)'; });
    setTimeout(function () { d.style.opacity = '0'; setTimeout(function () { d.remove(); }, 350); }, 5000);
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              // FASMED: aviso visible (antes el error quedaba escondido y parecía que no pasaba nada)
              window.fasmedToast(
                (response.description || 'No pudimos agregar este producto.') +
                  '<br><a href="' + window.routes.cart_url + '" style="color:#fff;text-decoration:underline">Ver carrito</a>',
                false
              );
              // Solo marcar "Agotado" si realmente no hay stock (no por límite de cantidad)
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              const reallySoldOut = response.status === 422 && /agotad|sold out/i.test(response.description || '');
              if (!soldOutMessage || !reallySoldOut) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const safeRender = () => {
              try {
                this.cart.renderContents(response);
              } catch (e) {
                console.error(e);
                window.fasmedToast(
                  '✓ Producto agregado · <a href="' + window.routes.cart_url + '" style="color:#fff;text-decoration:underline">Ver carrito</a>',
                  true
                );
              }
            };
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', safeRender);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', safeRender);
            }
          })
          .catch((e) => {
            console.error(e);
            window.fasmedToast('No pudimos agregar el producto. Intenta de nuevo.', false);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
